import { z } from "zod";

export const AuditEntityType = {
	PROFILES: "profiles",
	STUDENTS: "students",
	JOBS: "jobs",
	STUDENT_CENTRAL_POSTS: "student_central_posts",
	FEED_POSTS: "feed_posts",
	SCHOOLS: "schools",
	GROUPS: "groups",
	STAFF_SCHOOLS: "staff_schools",
	INVITATIONS: "invitations",
} as const;

export type AuditEntityType = (typeof AuditEntityType)[keyof typeof AuditEntityType];

export const AUDIT_ENTITY_TYPES = Object.values(AuditEntityType) as readonly AuditEntityType[];

export const auditEntityTypeSchema = z.enum(AuditEntityType);
